/** Human-readable page title for analytics (matches route labels). */
export function getPageTitle(pathname: string): string {
  switch (pathname) {
    case '/':
      return 'Home';
    case '/about':
      return 'About';
    case '/projects':
      return 'Projects';
    case '/skills':
      return 'Skills';
    case '/testimonials':
      return 'Testimonials';
    case '/contact':
      return 'Contact';
    case '/services/legacy-frontend-rescue':
      return 'Legacy Frontend Rescue';
    case '/health-check':
      return 'Frontend Health Check';
    case '/privacy':
      return 'Privacy Policy';
    case '/cookies':
      return 'Cookie Policy';
    case '/cookie-settings':
      return 'Cookie Settings';
    default:
      if (pathname.startsWith('/projects/')) {
        return 'Project Details';
      }
      return 'Not Found';
  }
}
